import {
  parseHubLifecycleSseDataLine,
  type HubLifecycleSseEvent,
} from "./hubLifecycleEvents";

export type { HubLifecycleSseEvent };
export { parseHubLifecycleSseDataLine };

export type HubLifecycleStreamOptions = {
  signal?: AbortSignal;
  onEvent?: (event: HubLifecycleSseEvent) => void;
  onError?: (error: unknown) => void;
};

/**
 * Lifecycle drain rides the browser-wide hub live socket started by
 * startHubDbPoolHolderStream. Kept so boot order call sites stay valid
 * without opening a second EventSource.
 */
export function startHubLifecycleStream(_options: HubLifecycleStreamOptions = {}): () => void {
  return () => undefined;
}
